
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://peizjxbewbhhxuetdxui.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlaXpqeGJld2JoaHh1ZXRkeHVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwNTUxNzcsImV4cCI6MjA1ODYzMTE3N30.sw6M_A02Ox_fMkhjt6cXlPQMDhJKlMO0niWRLoi4PN0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Re-export helper functions
export { safeSelect, safeInsert, safeUpdate } from './utils/safeQueries';
export { safeRPC } from './utils/rpcCalls';
export { executeParallelQueries, cachedQuery, bulkFetch } from './utils/queryBatch';
